import { difference, filter, groupBy, keys } from 'lodash';
import { useEffect, useState } from 'react';

export const useCheckFilterButton = ({
  busType,
  chooseClass,
  hourOfDeparture,
  hourOfArrival,
  priceRank,
  checkboxValues,
}: {
  busType: any;
  chooseClass: any;
  hourOfDeparture: any;
  hourOfArrival: any;
  priceRank: any;
  checkboxValues: any;
}) => {
  const [isFilterable, setIsFilterable] = useState<boolean>(false);

  useEffect(() => {
    const result = groupBy(
      filter(checkboxValues, checkbox => checkbox.checked),
      'value',
    );
    const resultKeys = keys(result);

    if (
      busType !== '' ||
      chooseClass !== -1 ||
      difference(hourOfDeparture, [100, 86399999]).length !== 0 ||
      difference(hourOfArrival, [100, 86399999]).length !== 0 ||
      difference(priceRank, [1, 20]).length !== 0 ||
      resultKeys.length !== 0
    ) {
      setIsFilterable(true);
    } else {
      setIsFilterable(false);
    }
  }, [busType, chooseClass, hourOfDeparture, hourOfArrival, priceRank, checkboxValues]);

  return isFilterable;
};
